import { useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, FormGroup, Label, Input } from "reactstrap";
import { infoApi } from "../../services/InfoService";
import Board from "../../assets/images/board.png";
import Board_M from "../../assets/images/board_m.png";

export const InfoPopover = ({ isAdmin, boardKey = "board-general", adminOnly = false, notify = false, boardImageType = "default", userId }) => {
  console.log(userId);
  const [modalOpen, setModalOpen] = useState(false);
  const toggle = () => setModalOpen((prev) => !prev);

  const { data, isLoading, refetch } = infoApi.useGetBoardContentQuery(boardKey);
  const [updateBoardInfo, { isLoading: isSaving }] = infoApi.useUpdateBoardContentMutation();
  const [deleteBoardInfo] = infoApi.useDeleteBoardContentMutation();

  const [editMode, setEditMode] = useState(false);
  const [content, setContent] = useState("");

  const handleEdit = () => {
    setContent(data?.content || "");
    setEditMode(true);
  };

  const handleSave = async () => {
    await updateBoardInfo({ key: boardKey, content, notify });
    await refetch();
    setEditMode(false);
  };

  const handleClear = async () => {
    await deleteBoardInfo(boardKey);
    await refetch();
    setContent("");
    setEditMode(false);
  };

  useEffect(() => {
    if (!editMode && data?.content) {
      setContent(data.content);
    }
  }, [data, editMode]);

  const ADMIN_USER_IDS = ["69b266e043ee4c0adf23fdc0", "69b266a343ee4c0adf23fda0", "69bff7f7a675991ac050283f"];

  const hasAdminAccess = isAdmin || ADMIN_USER_IDS.includes(String(userId));

  if (adminOnly && !hasAdminAccess) return null;

  const boardImage = boardImageType === "admin" ? Board_M : Board;

  return (
    <>
      <div
        className="d-flex justify-content-end position-relative"
        style={{
          width: "fit-content",
          cursor: "pointer",
          zIndex: 2,
        }}
        onClick={toggle}
        title="Information"
      >
        <img
          src={boardImage}
          alt="Info"
          style={{
            width: "30px",
            height: "30px",
            display: "block",
          }}
        />

        {data?.content && (
          <span
            className="position-absolute badge rounded-pill bg-danger"
            style={{
              top: "0px",
              right: "-6px",
              fontSize: "10px",
              padding: "4px 6px",
              pointerEvents: "none",
            }}
          >
            !
          </span>
        )}
      </div>

      <Modal isOpen={modalOpen} toggle={toggle} size="md">
        <div style={{ maxHeight: "80vh", display: "flex", flexDirection: "column" }}>
          <ModalHeader toggle={toggle}>
            <b>📘 Information Board</b>
          </ModalHeader>

          <ModalBody style={{ overflowY: "auto", flex: 1 }}>
            {isLoading ? (
              <p>Loading...</p>
            ) : editMode ? (
              <FormGroup>
                <Label for={`boardContent-${boardKey}`}>Information</Label>
                <Input type="textarea" id={`boardContent-${boardKey}`} rows={12} value={content} onChange={(e) => setContent(e.target.value)} placeholder="Write instructions or notes here..." />
              </FormGroup>
            ) : (
              <pre className="mb-0" style={{ whiteSpace: "pre-wrap" }}>
                {data?.content || "No information available. Click Edit to add instructions."}
              </pre>
            )}
          </ModalBody>

          <ModalFooter>
            {hasAdminAccess && !editMode && (
              <>
                <Button color="warning" onClick={handleEdit}>
                  Edit
                </Button>
                <Button color="danger" onClick={handleClear}>
                  Clear Board
                </Button>
              </>
            )}

            {editMode && (
              <>
                <Button color="primary" onClick={handleSave} disabled={isSaving}>
                  {isSaving ? "Saving..." : "Save"}
                </Button>
                <Button color="secondary" onClick={() => setEditMode(false)}>
                  Cancel
                </Button>
              </>
            )}

            {!editMode && (
              <Button color="primary" onClick={toggle}>
                Got it
              </Button>
            )}
          </ModalFooter>
        </div>
      </Modal>
    </>
  );
};
